import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product",
  "use": "icon-product-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-product\"><defs><style type=\"text/css\"></style></defs><path d=\"M467.2 868.608V575.36l-313.6-179.2v293.248l313.6 179.2z m89.6 0l313.6-179.2V396.16l-313.6 179.2v293.248z m267.776-549.44L512 140.608l-312.576 178.56L512 497.792l312.576-178.56zM64 293.376l448-256 448 256v448l-448 256-448-256v-448z\" p-id=\"3488\" fill=\"#333333\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol